import { Locator, Page } from "@playwright/test";

/**
 * This utility adds a listener for a custom event and displays the event count and detail
 * in a div which is appended to the document body. This info element can be used in tests
 * where custom events need to be tested.
 *
 * @param page
 * @param eventName
 * @returns Promise with the info element locator
 */
export const initTestEventInfo = async (page: Page, eventName: string): Promise<Locator> => {
    await page.evaluate(
        ({ eventName }) => {
            let counter = 0;
            const infoEl = document.createElement("div");
            infoEl.setAttribute("id", `test-event-info-${eventName}`);
            document.body.appendChild(infoEl);
            document.addEventListener(eventName, (event) => {
                counter++;
                infoEl.innerHTML = `${event.type} (${counter}) ${JSON.stringify((event as CustomEvent).detail)}`;
            });
        },
        { eventName }
    );
    return page.locator(`#test-event-info-${eventName}`);
};
